import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestNews() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="w-1.5 h-5 bg-accent-500 rounded-full"></span>
              <span className="text-accent-600 text-sm font-medium tracking-wider">LATEST</span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 tracking-tight">
              最新爆料
            </h2>
          </div>
          <Link
            to="/category/entertainment"
            className="text-foreground-500 hover:text-foreground-800 text-sm font-medium transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`吃瓜网最新爆料 - ${article.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-4 pt-4 border-t border-background-200/70 text-foreground-400 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}